export default "__VITE_ASSET__d644ab26__"